export const ORGANISATION_STATES = {
  ACTIVE: 1,
  UNLISTED: 2,
  INACTIVE: 3,
  DELETED: 4,
  PENDING: 5,
};

export const activeStates = [
  {
    key: ORGANISATION_STATES.ACTIVE,
    value: ORGANISATION_STATES.ACTIVE,
    name: 'Active',
    text: 'Active',
  },
  {
    key: ORGANISATION_STATES.UNLISTED,
    value: ORGANISATION_STATES.UNLISTED,
    name: 'Unlisted',
    text: 'Unlisted',
  },
  {
    key: ORGANISATION_STATES.INACTIVE,
    value: ORGANISATION_STATES.INACTIVE,
    name: 'Inactive',
    text: 'Inactive',
  },
  {
    key: ORGANISATION_STATES.DELETED,
    value: ORGANISATION_STATES.DELETED,
    name: 'Deleted',
    text: 'Deleted',
  },
  {
    key: ORGANISATION_STATES.PENDING,
    value: ORGANISATION_STATES.PENDING,
    name: 'Pending',
    text: 'Pending',
  },
];

// phasing out this but data might still be there
export const FILTERED_ACTIVE_STATES = activeStates.filter(
  a => a.key !== ORGANISATION_STATES.UNLISTED && a.key !== ORGANISATION_STATES.INACTIVE
);

export const userActiveStates = [
  { key: 1, name: 'Active' },
  { key: 2, name: 'Invited' },
  { key: 3, name: 'Disabled' },
  { key: 4, name: 'Locked out' },
  { key: 5, name: 'Deleted' },
  { key: 6, name: 'Password to reset' },
];
